/* eslint-disable no-undef */

(() => {
  if (document.getElementById('secondary-exercises-popup')) {
    const secondaryExercisesPopupButton = document.querySelector(
      '.js-secondary-exercises-popup'
    );

    const setSecondaryExercisesPopupCookie = () => {
      if (
        window.Sofatutor.consentGivenForCategory('necessary') &&
        !$.cookie('_sofatutor_secondary_exercises_fourth_grade_popup_seen')
      )
        $.cookie(
          '_sofatutor_secondary_exercises_fourth_grade_popup_seen',
          true,
          {
            expires: 120, // 120 days
            path: '/'
          }
        );
    };

    secondaryExercisesPopupButton.addEventListener('click', () => {
      setSecondaryExercisesPopupCookie();

      $('#secondary-exercises-popup').foundation('close');
    });
  }
})();
